import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Hreflang } from "@/components/Hreflang";
import { AltPathProvider } from "@/i18n";
import LocationLanding from "@/pages/LocationLanding";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import Pricing from "@/pages/Pricing";
import NotFound from "@/pages/NotFound";
import Submit from "@/pages/Submit";
import PaymentResult from "@/pages/PaymentResult";
import BusinessDetail from "@/pages/BusinessDetail";
import ResumePayment from "@/pages/ResumePayment";
import ClaimListing from "@/pages/ClaimListing";
import ClaimByCard from "@/pages/ClaimByCard";
import ManageListing from "@/pages/ManageListing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AltPathProvider>
          <ScrollToTop />
          <Hreflang />
          <Header />
          <main data-testid="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/harga" element={<Pricing />} />
              <Route path="/business/:listingId" element={<BusinessDetail />} />
              <Route path="/resume/:listingId" element={<ResumePayment />} />
              <Route path="/claim" element={<ClaimListing />} />
              <Route path="/claim-card/:listingId" element={<ClaimByCard />} />
              <Route path="/manage/:listingId" element={<ManageListing />} />
              <Route path="/submit" element={<Submit />} />
              <Route path="/payment-result" element={<PaymentResult />} />
              <Route path="/terma" element={<Terms />} />
              <Route path="/privasi" element={<Privacy />} />
              <Route path="/pemulangan" element={<Refund />} />
              <Route path="/hubungi" element={<Contact />} />
              <Route path="/en" element={<Home />} />
              <Route path="/en/directory" element={<Directory />} />
              <Route path="/en/pricing" element={<Pricing />} />
              <Route path="/en/terms" element={<Terms />} />
              <Route path="/en/privacy" element={<Privacy />} />
              <Route path="/en/refund-policy" element={<Refund />} />
              <Route path="/en/contact" element={<Contact />} />
              <Route path="/direktori/:categorySlug/:stateSlug" element={<LocationLanding />} />
              <Route path="/direktori/:categorySlug/:stateSlug/:districtSlug" element={<LocationLanding />} />
              <Route path="/en/directory/:categorySlug/:stateSlug" element={<LocationLanding />} />
              <Route path="/en/directory/:categorySlug/:stateSlug/:districtSlug" element={<LocationLanding />} />
              <Route path="/en/submit" element={<Submit />} />
              <Route path="/en/claim" element={<ClaimListing />} />
              <Route path="/en/payment-result" element={<PaymentResult />} />
              <Route path="/en/business/:listingId" element={<BusinessDetail />} />
              <Route path="/en/claim-card/:listingId" element={<ClaimByCard />} />
              <Route path="/en/manage/:listingId" element={<ManageListing />} />
              <Route path="/en/resume/:listingId" element={<ResumePayment />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-center" richColors />
          </AltPathProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
